import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import Swal from 'sweetalert2';
import $ from 'jquery';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { baseurl } from '../utility/helper';

const ChapterList = () => {
  const roleid =  parseInt(sessionStorage.getItem("userroleId"));
  const [chapters, setChapters] = useState([]);
  const tableRef = useRef(null);
  const navigate = useNavigate();

  const fetchChapters = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${baseurl}/admin/chapters`, {
        method: 'GET',
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      console.log('Fetched data:', data);
      // You can perform any date formatting or adjustments here if needed.
      setChapters(data);
    } catch (error) {
      console.error('Error fetching chapters:', error);
    }
  };

  useEffect(() => {
    fetchChapters();
  }, []);

  useEffect(() => {
    const tableElement = tableRef.current;
    if (tableElement) {
      if (!$.fn.DataTable.isDataTable(tableElement)) {
        $(tableElement).DataTable({
          dom: 'Blfrtip',
          pageLength: 25,
          lengthMenu: [[10, 25, 50, 100, 250, 500, -1], [10, 25, 50, 100, 250, 500, "All"]],
          buttons: [
            {
              extend: 'copyHtml5',
              className: 'btn btn-primary dttable',
              exportOptions: { columns: ':visible' },
            },
            {
              extend: 'excelHtml5',
              className: 'btn btn-primary dttable',
              exportOptions: { columns: ':visible' },
            },
            {
              extend: 'csvHtml5',
              className: 'btn btn-primary dttable',
              exportOptions: { columns: ':visible' },
            },
            {
              extend: 'pdfHtml5',
              className: 'btn btn-primary dttable',
              exportOptions: { columns: ':visible' },
            },
            {
              extend: 'print',
              className: 'btn btn-primary dttable',
              exportOptions: { columns: ':visible' },
            },
          ],
          data: chapters,
          // Define columns to match your chapter structure.
          columns: [
            { data: 'chapter_id', title: 'ID' },
            { data: 'chapter_name', title: 'Name' },
            { data: 'chapter_desc', title: 'Description' },
            { data: 'chapter_status', title: 'Status' },
            { data: 'chapter_email', title: 'Email' },
            { data: 'chapter_president', title: 'President Name' },
            { data: 'president_mobile', title: 'President No' },
            { data: null, title: 'Action' },
          ],
          columnDefs: [
            {
              // Render the ID as a clickable link to view details.
              targets: 0,
              render: function (data) {
                return `<a href="#" class="edit-link" data-id="${data}">${data}</a>`;
              },
            },
            {
              // Render the Action column with Edit and Delete buttons.
              targets: 7,
              render: function (data, type, row) {
                const editIcon = `<a href="#" class="edit-icon btn btn-warning btn-sm me-2 text-black" data-id="${row.chapter_id}">
                                    <i class="fas fa-edit"></i>&nbsp; Edit</a>`;
                // const deleteIcon = roleid == 1
                //   ? `<a href="#" class="delete-icon btn btn-danger btn-sm" style="color:white" data-id="${row.chapter_id}">
                //        <i class="fas fa-trash"></i>&nbsp; Delete</a>`
                //   : '';
                return `${editIcon}`;
              },
            },
          ],
          initComplete: function () {
            $('.dt-length select').addClass('form-select form-select-sm');
          }
        });
      } else {
        // If DataTable is already initialized, clear and redraw with updated data.
        const table = $(tableElement).DataTable();
        table.clear();
        table.rows.add(chapters);
        table.draw();
      }
    }

    // Unbind previous event handlers to avoid duplicates.
    $(document).off('click', '.edit-icon');
    $(document).off('click', '.edit-link');
    $(document).off('click', '.delete-icon');

    // Handler: clicking the edit icon opens the chapter in edit mode.
    $(document).on('click', '.edit-icon', function (e) {
      e.preventDefault();
      const chapterId = $(this).data('id');
      navigate('/admin/EditChapter', { state: { chapterId: chapterId, edit: true } });
    });

    // Handler: clicking the ID link opens chapter in view (read‑only) mode.
    $(document).on('click', '.edit-link', function (e) {
      e.preventDefault();
      const chapterId = $(this).data('id');
      navigate('/admin/EditChapter', { state: { chapterId: chapterId } });
    });

    // Handler: clicking the delete icon asks for confirmation, then calls the DELETE endpoint.
    $(document).on('click', '.delete-icon', function (e) {
      e.preventDefault();
      const chapterId = $(this).data('id');
      Swal.fire({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          const token = sessionStorage.getItem("token");
          $.ajax({
            url: `${baseurl}/admin/chapters/${chapterId}`,
            type: 'DELETE',
            headers: {
              'Authorization': token,
              'Content-Type': 'application/json'
            },
            success: function (response) {
              Swal.fire({
                title: 'Deleted!',
                text: response.message,
                icon: 'success',
              }).then(() => {
                // fetchChapters();
              });
            },
            error: function (xhr, status, error) {
              Swal.fire({
                title: 'Error!',
                text: (xhr.responseJSON && xhr.responseJSON.message) ? xhr.responseJSON.message : 'Error deleting chapter.',
                icon: 'error',
              });
            },
          });
        }
      });
    });

    // Cleanup: unbind events and destroy DataTable when the component unmounts.
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(document).off('click', '.edit-icon');
      $(document).off('click', '.edit-link');
      $(document).off('click', '.delete-icon');
    };
  }, [chapters, navigate, roleid]);

  return (
    <div className="content container-fluid">
      <div className="container mt-4">
        <div className="profile-section">
          <div className="row">
            <div style={{ width: '100%', textAlign: '-webkit-right', paddingRight: '37px', fontSize: 'medium' }}>
              <button style={{ border: 'none', padding: '0', margin: '0', cursor: 'pointer' }}>
                <Link to="/admin/Chapter" style={{ display: 'block', padding: '0.5rem 1rem', textDecoration: 'none', color: 'inherit' }}>
                  <i className="bx bxs-plus-circle mr-2"></i> Add Chapter
                </Link>
              </button>
            </div>
          </div>
          <br />
          <div className="list">
            <div className="row">
              <div className="col-12" style={{ overflow: 'auto' }}>
                <table ref={tableRef} className="table table-striped table-bordered" style={{ width: '100%' }}>
                  {/* DataTables will generate the header and body */}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChapterList;
